module.exports = __webpack_public_path__ + "03_glasses_brown.69c6f7b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer4/03_glasses_brown.png
// module id = +hZR
// module chunks = 0